import { authGuard, permissionGuard, systemAdminGuard } from "./guards";
import Vue from "vue";
import Router from "vue-router";
import Book from "@/pages/Book.vue";
import Home from "../pages/Home.vue";
import Login from "@/pages/Login.vue";
import Video from "../pages/Video.vue";
import MyCart from "../pages/MyCart.vue";
import Manage from "../pages/Manage.vue";
import Library from "@/pages/Library.vue";
import Profile from "../pages/Profile.vue";
import Content from "../pages/Content.vue";
import Checkout from "../pages/Checkout.vue";
import Simulated from "../pages/Simulated.vue";
import AuthToken from "../pages/Auth/AuthToken.vue";
import ContentDetail from "../components/CategoryCard.vue";
import CustomizeProfile from "../pages/CustomizeProfile.vue";
import EmbedCourse from "../pages/EmbedCourse.vue";
import DefinirSenha from "../pages/Auth/DefinirSenha.vue";

import AdminDashboard from "@/pages/Admin/Dashboard.vue";
import AdminUsers from "@/pages/Admin/Users.vue";
import AdminPartners from "@/pages/Admin/Partners.vue";
import AdminFinancial from "@/pages/Admin/Financial.vue";
import AdminPricing from "@/pages/Admin/Pricing.vue";
import AdminSimulator from "@/pages/Admin/Simulator.vue";
import SearchResults from "@/pages/SearchResults.vue";
import Favorites from "@/pages/Favorites.vue";
import HelpCenter from "@/pages/HelpCenter.vue";

Vue.use(Router);

const router = new Router({
  parseQuery(query) {
    const res = {};
    query = query.trim().replace(/^(\?|#|&)/, '');
    if (!query) {
      return res;
    }
    query.split('&').forEach(param => {
      const parts = param.split('=');
      const key = decodeURIComponent(parts[0]);
      const val = parts[1] !== undefined
        ? decodeURIComponent(parts[1].replace(/\+/g, ' '))
        : null;
      res[key] = val;
    });
    return res;
  },
  stringifyQuery(obj) {
    const res = Object.keys(obj)
      .map(key => {
        const val = obj[key];
        if (val === undefined) {
          return '';
        }
        if (val === null) {
          return encodeURIComponent(key);
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(val).replace(/%20/g, '+')}`;
      })
      .filter(x => x.length > 0)
      .join('&');
    return res ? `?${res}` : '';
  },
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/search-results",
      name: "SearchResults",
      component: SearchResults,
      meta: { requiresAuth: true },
    },
    {
      path: "/book",
      name: "book",
      component: Book,
      meta: { requiresAuth: true },
    },
    {
      path: "/categoria/:tipo",
      name: "category",
      component: ContentDetail,
      meta: { requiresAuth: true },
    },
    {
      path: "/content",
      name: "content",
      component: Content,
      meta: { requiresAuth: true },
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: { requiresAuth: true },
    },
    {
      path: "/library",
      name: "library",
      component: Library,
      meta: { requiresAuth: true },
    },
    {
      path: "/",
      name: "root",
      component: Login,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: { requiresAuth: true },
    },
    {
      path: "/simulated",
      name: "simulated",
      component: Simulated,
      meta: { requiresAuth: true },
    },
    {
      path: "/video",
      name: "video",
      component: Video,
      meta: { requiresAuth: true },
    },
    {
      path: "/auth",
      name: "auth",
      component: AuthToken,
    },
    {
      path: "/definir-senha",
      name: "definir-senha",
      component: DefinirSenha,
    },
    {
      path: "/mycart",
      name: "MyCart",
      component: MyCart,
      meta: { requiresAuth: true },
    },
    {
      path: "/checkout",
      name: "Checkout",
      component: Checkout,
      meta: { requiresAuth: true },
    },
    {
      path: "/favorites",
      name: "Favorites",
      component: Favorites,
      meta: { requiresAuth: true },
    },
    {
      path: "/customizeprofile",
      name: "CustomizeProfile",
      component: CustomizeProfile,
      meta: { requiresAuth: true },
    },
    {
      path: "/help",
      name: "HelpCenter",
      component: HelpCenter,
      meta: { requiresAuth: true },
    },
    {
      path: "/manage",
      name: "Manage",
      component: Manage,
      meta: { requiresAuth: true },
    },
    {
      path: "/admin/dashboard",
      name: "AdminDashboard",
      component: AdminDashboard,
      meta: { requiresAuth: true, requiresSystemAdmin: true },
    },
    {
      path: "/admin/users",
      name: "AdminUsers",
      component: AdminUsers,
      meta: { requiresAuth: true, requiresSystemAdmin: true },
    },
    {
      path: "/admin/partners",
      name: "AdminPartners",
      component: AdminPartners,
      meta: { requiresAuth: true, requiresSystemAdmin: true },
    },
    {
      path: "/admin/financial",
      name: "AdminFinancial",
      component: AdminFinancial,
      meta: { requiresAuth: true, requiresSystemAdmin: true },
    },
    {
      path: "/admin/pricing",
      name: "AdminPricing",
      component: AdminPricing,
      meta: { requiresAuth: true, requiresSystemAdmin: true },
    },
    {
      path: "/admin/simulator",
      name: "AdminSimulator",
      component: AdminSimulator,
      meta: { requiresAuth: true, requiresSystemAdmin: true },
    },
    {
      path: "/embed/:hash",
      name: "EmbedCourse",
      component: EmbedCourse,
      meta: { requiresAuth: false, isEmbed: true },
    }
  ],
});

// Aplicar guards de navegação
router.beforeEach(authGuard);
router.beforeEach(permissionGuard);

// Guard específico para rotas de sistema (apenas is_admin = 1)
router.beforeEach((to, from, next) => {
  if (to.meta.requiresSystemAdmin) {
    return systemAdminGuard(to, from, next);
  }
  next();
});

export default router;
